// extracted by mini-css-extract-plugin
export default {"overlay-container":"Overlay_overlay-container__EwCVq","overlay":"Overlay_overlay__7Ina8","active":"Overlay_active__y+wc7","inactive":"Overlay_inactive__SNdFD"};